import { queryUpdateProps } from "src/interfaces";
import { connect } from "react-redux";
import { RootState } from "src/stores";
import SlideoverModal from "src/components/SlideoverModal";
import {
  FormCheck,
  FormInput,
  FormLabel,
  FormSwitch,
} from "src/base-components/Form";
import clsx from "clsx";
import PhoneInput from "src/components/PhoneInput";
import Button from "src/base-components/Button";
import Lucide from "src/base-components/Lucide";
import { useEffect, useState } from "react";
import { parsePhoneNumber } from "libphonenumber-js";
import WhatsappIcon from "../../../../assets/images/icon/whatsapp-logo.svg";
import ErrorMessage from "src/base-components/FormErrorValidation/ErrorMessage";
import { PlusIcon, XCircleIcon } from "lucide-react";
const Component = ({
  visible,
  setVisible,
  model = {} as any,
  setModel,
  onSubmit,
  onChangeInput,
}: {
  visible: boolean;
  setVisible: Function;
  model: any;
  setModel: any;
  onSubmit: any;
  onChangeInput: any;
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [addAlternatePhone, setAddAlternatePhone] = useState(false);
  const [addedPhones, setAddedPhones] = useState<string[]>([]);
  const [currentPhone, setCurrentPhone] = useState<string>("");
  const [alreadyAddedPhone, setAlreadyAddedPhone] = useState<boolean>(false);
  const [repeatError, setRepeatError] = useState<boolean>(false);

  // adding the validation over the phone numbers
  const [primaryDialCodeError, setPrimaryDialCodeError] = useState(false);
  const [primaryPhoneError, setPrimaryPhoneError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState("Please enter a valid number");

  // adding the validation over the alternative numbers
  const [altDialCodeError, setAltDialCodeError] = useState(false);
  const [altPhoneError, setAltPhoneError] = useState(false);
  const [altPhoneNumberError, setAltPhoneNumberError] = useState("Please enter a valid number")


  const handleAlternatePhone = (payload: {
    phone: string;
    dialCode: string;
  }) => {
    setCurrentPhone(payload?.dialCode + payload?.phone);
    setAlreadyAddedPhone(false);
  };
  useEffect(() => {
    if (model?.alternative_phone_numbers) {
      const arr = model?.alternative_phone_numbers
        .split(",")
        .map((s) => s.trim());
      setAddedPhones(arr);
    } else {
      setAddedPhones([]);
    }
  }, [model?.alternative_phone_numbers]);

  const handleAddPhone = () => {

    if (altDialCodeError || altPhoneError) {
      return;
    }

    if (
      addedPhones.includes(currentPhone) ||
      currentPhone === model?.country_code + model?.phone
    ) {
      setAlreadyAddedPhone(true);
      return;
    } else {
      setAlreadyAddedPhone(false);
    }
    if (currentPhone && !addedPhones.includes(currentPhone)) {
      let newSet = [...addedPhones, currentPhone];
      setAddedPhones(newSet);
      setCurrentPhone("");
      setModel({
        ...model,
        alternative_phone_numbers:
          newSet?.length > 0 ? newSet?.join(", ") : null,
      });
      setAddAlternatePhone(false);
    }
  };

  const handleRemovePhone = (phoneToRemove: string) => {
    let newSet = addedPhones.filter((phone) => phone !== phoneToRemove);
    if (phoneToRemove === model.wp_country_code + model?.whatsapp_phone) {
      setModel({ ...model, whatsapp_phone: "", wp_country_code: "" });
    }
    setAddedPhones(newSet);
    setModel({
      ...model,
      alternative_phone_numbers: newSet?.length > 0 ? newSet?.join(", ") : null,
    });
  };

  return (
    <SlideoverModal
      size="md"
      headerTitle={"Update Customer"}
      visible={visible}
      onClose={(value) => {
        setVisible(value);
      }}
    >
      <div className="h-full w-full flex flex-col">
        <div className="w-full mt-3">
          <FormLabel className="">Name</FormLabel>

          <FormInput
            name="fullname"
            value={model?.fullname}
            onChange={onChangeInput}
            placeholder="Enter customer name..."
            required
            type="text"
            className={clsx(
              "first:rounded-b-none first:md:rounded-bl-md ",
              "first:md:rounded-r-none [&:not(:first-child):not(:last-child)]:-mt-px ",
              "[&:not(:first-child):not(:last-child)]:md:mt-0 [&:not(:first-child):not(:last-child)]:md:-ml-px ",
              "[&:not(:first-child):not(:last-child)]:rounded-none last:rounded-t-none last:md:rounded-l-none ",
              "last:md:rounded-tr-md last:-mt-px last:md:mt-0 last:md:-ml-px focus:z-10"
            )}
          />
        </div>
        <div className="w-full mt-3">
          <FormLabel className="">Email</FormLabel>

          <FormInput
            name="email"
            value={model?.email}
            onChange={onChangeInput}
            placeholder="Enter customer email..."
            type="email"
            className={clsx(
              "first:rounded-b-none first:md:rounded-bl-md ",
              "first:md:rounded-r-none [&:not(:first-child):not(:last-child)]:-mt-px ",
              "[&:not(:first-child):not(:last-child)]:md:mt-0 [&:not(:first-child):not(:last-child)]:md:-ml-px ",
              "[&:not(:first-child):not(:last-child)]:rounded-none last:rounded-t-none last:md:rounded-l-none ",
              "last:md:rounded-tr-md last:-mt-px last:md:mt-0 last:md:-ml-px focus:z-10"
            )}
          />
        </div>
        <div className="w-full mt-3">
          <FormLabel className="">Phone (primary)</FormLabel>
          <div>
            <div className="flex space-x-3 w-full">
              <PhoneInput
                {...({} as any)}
                value={`${model?.country_code}${model?.phone}` || ""}
                name="phone"
                placeholder="#Phone"
                className="rounded-r-md z-10"
                onChange={(payload) => {
                  const { phone, dialCode } = payload;
                  if (addedPhones?.includes(dialCode + phone)) {
                    setRepeatError(true);
                    return;
                  } else {
                    setRepeatError(false);
                  }

                  setModel({
                    ...model,
                    phone: phone,
                    country_code: dialCode,
                  });
                }}
                dialCodeError={primaryDialCodeError}
                phoneError={primaryPhoneError || repeatError}
                setDialCodeError={setPrimaryDialCodeError}
                setPhoneNumberError={setPrimaryPhoneError}
                errorPhone={phoneNumberError}
                setErrorPhone={setPhoneNumberError}
              />

              <div className="flex items-center">
                <FormCheck.Input
                  value={model?.isDefault}
                  checked={model?.isDefault == 1}
                  onChange={() => {
                    setModel({
                      ...model,
                      isDefault: model?.isDefault == 0 ? 1 : 0,
                      wp_country_code: "",
                      whatsapp_phone: "",
                    });
                  }}
                  id="remember-me"
                  name="isPersist"
                  type="checkbox"
                  className="mr-2 border"
                />
                <label className="cursor-pointer select-none">
                  <img src={WhatsappIcon} className="w-8 h-8" />
                </label>
              </div>
            </div>
            {repeatError ? (
              <ErrorMessage
                message={
                  "This phone number has already been added. Please enter a different number." as any
                }
              />
            ) : null}
          </div>
          {addedPhones.length > 0 && (
            <div className="flex flex-col gap-2 mt-3 w-full">
              <span className="flex flex-row items-center justify-items-end text-primary font-bold mt-4 cursor-pointer">
                Alternate Phone Numbers
              </span>
              {addedPhones.map((phone, index) => (
                <div
                  key={index}
                  className="flex w-full items-center justify-between "
                >
                  <div className="flex flex-row items-center">
                    <PhoneInput
                      {...({} as any)}
                      value={phone || ""}
                      name="phone"
                      placeholder="#Phone (alternate)"
                      disabled={true}
                      className="rounded-r-md z-10"
                      onChange={(payload) => { }}
                    />

                    <FormCheck.Input
                      onClick={() => {
                        let countryCode = "";
                        let nationalNumber = "";

                        try {
                          const parsed = parsePhoneNumber(phone || "");
                          countryCode = `+${parsed.countryCallingCode}`;
                          nationalNumber = parsed.nationalNumber;
                        } catch (e) {
                          console.error("Invalid phone number", e);
                        }

                        setModel({
                          ...model,
                          isDefault: 0,
                          wp_country_code:
                            model?.whatsapp_phone === nationalNumber
                              ? ""
                              : countryCode,
                          whatsapp_phone:
                            model?.whatsapp_phone === nationalNumber
                              ? ""
                              : nationalNumber,
                        });
                      }}
                      id="remember-me"
                      name="isPersist"
                      type="checkbox"
                      className="mx-2 border"
                      checked={
                        model?.wp_country_code + model?.whatsapp_phone === phone
                      }
                    />
                    <label className="cursor-pointer select-none">
                      <img src={WhatsappIcon} className="w-8 h-8" />
                    </label>
                  </div>
                  <XCircleIcon
                    className="text-red-600 w-4 h-4 cursor-pointer"
                    onClick={() => handleRemovePhone(phone)}
                  />
                </div>
              ))}
            </div>
          )}
          {addAlternatePhone && addedPhones?.length < 4 ? (
            <div>
              <div className="flex flex-row gap-3 justify-start items-center mt-3 w-full">
                <PhoneInput
                  {...({} as any)}
                  value={currentPhone}
                  placeholder="Alternate Phone Number"
                  className="border-slate-300/100 w-[100%] "
                  onChange={handleAlternatePhone}
                  dialCodeError={altDialCodeError}
                  phoneError={altPhoneError || alreadyAddedPhone}
                  setDialCodeError={setAltDialCodeError}
                  setPhoneNumberError={setAltPhoneError}
                  errorPhone={altPhoneNumberError}
                  setErrorPhone={setAltPhoneNumberError}
                />
                {currentPhone?.length > 6 && (
                  <Button
                    className="flex items-center py-1 cursor-pointer justify-center md:w-auto text-white bg-primary"
                    type="button"
                    onClick={handleAddPhone}
                  >
                    <Lucide
                      icon="Check"
                      className="stroke-[2] w-4 h-4 mr-2 -ml-2"
                    />
                    Add
                  </Button>
                )}

                <XCircleIcon
                  className="flex items-center text-red-900  w-7 h-6 border-none rounded-full cursor-pointer"
                  onClick={() => {
                    setAddAlternatePhone(!addAlternatePhone);
                  }}
                />
              </div>
              {alreadyAddedPhone ? (
                <ErrorMessage
                  message={
                    "This phone number has already been added. Please enter a different number." as any
                  }
                />
              ) : null}
            </div>
          ) : addedPhones?.length < 4 ? (
            <span
              onClick={() => {
                setAddAlternatePhone(!addAlternatePhone);
              }}
              className="flex flex-row items-center justify-items-end text-primary font-bold mt-4 cursor-pointer"
            >
              <PlusIcon className="mr-0.5" size={18} />{" "}
              {addedPhones?.length > 0
                ? "Add more"
                : "Add Alternate Phone Numbers"}
            </span>
          ) : null}
        </div>
        {/* {model?.isDefault == 0 && (
          <div className="w-full mt-3">
            <FormLabel className="">Whatsapp</FormLabel>
            <div className="flex space-x-3">
              <PhoneInput
                {...({} as any)}
                value={`${model?.wp_country_code}${model?.whatsapp_phone}`}
                placeholder="#Whatsapp Phone"
                required={true}
                onChange={(data) => {
                  setModel((previous) => {
                    return {
                      ...previous,
                      wp_country_code: data?.dialCode,
                      whatsapp_phone: data?.phone,
                    };
                  });
                }}
              />
            </div>
          </div>
        )} */}
        <Button
          className="w-full px-10 md:w-auto text-white bg-primary mt-auto ml-auto"
          type="button"
          // onClick={onSubmit}
          onClick={(e) => {
            e.preventDefault();
            if (primaryDialCodeError || primaryPhoneError) return;
            onSubmit(e)
          }}
          disabled={submitting}
          loading={submitting}
        >
          <Lucide icon="Check" className="stroke-[1.3] w-4 h-4 mr-2 -ml-2" />
          Submit
        </Button>
      </div>
    </SlideoverModal>
  );
};

const mapStateToProps = ({ }: RootState) => ({});

const mapDispatchToProps = (dispatch: any) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Component);